import { useEffect, useState } from "react";
import * as THREE from "three";

const cache = new Map<string, Promise<THREE.Texture>>();

const loadTexture = (url: string): Promise<THREE.Texture> => {
  let promise = cache.get(url);
  if (!promise) {
    promise = new Promise((resolve, reject) => {
      new THREE.TextureLoader().load(
        url,
        (tex) => {
          tex.colorSpace = THREE.SRGBColorSpace;
          resolve(tex);
        },
        undefined,
        reject,
      );
    });
    cache.set(url, promise);
  }
  return promise;
};

/** Loads a set of image URLs as real (non-pixelated) THREE textures, preserving aspect ratio. */
export const useImageTextures = (urls: string[]) => {
  const [textures, setTextures] = useState<THREE.Texture[]>([]);
  const [aspect, setAspect] = useState<number | null>(null);
  const key = urls.join("|");

  useEffect(() => {
    let cancelled = false;
    Promise.all(urls.map(loadTexture))
      .then((loaded) => {
        if (cancelled) return;
        setTextures(loaded);
        const first = loaded[0];
        if (first?.image) {
          setAspect(first.image.width / first.image.height);
        }
      })
      .catch(() => {
        /* fall through — caller should show a placeholder */
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { textures, aspect };
};
